<script setup lang="ts">
import UserRegisterPresentationView from '../../views/UserRegisterPresentationView/UserRegisterPresentationView.vue';
import UserRegisterPresentationMobileView from '../../views/UserRegisterPresentationMobileView/UserRegisterPresentationMobileView.vue';
import { useQuasar } from 'quasar';

const $q = useQuasar();

// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()
</script>

<template>
  <q-page class="column">
    <div class="col fit">
      <UserRegisterPresentationMobileView v-if="$q.platform.is.mobile" />
      <UserRegisterPresentationView v-else />
    </div>
  </q-page>
</template>
